import { memo, useMemo } from 'react';
import { ReadHolidayResponseDto } from '@/api.types';
import { MESES, diasDaSemana } from '@/shared/utils/datas';
import { diaEmTimestamp } from './holidays-calendar.utils';

interface HolidayCalendarMonthProps {
  /** Mês 0-based (janeiro = 0), alinhado a `Date.getMonth()` e `diaEmTimestamp`. */
  mes: number;
  ano: number;
  hoje: number;
  feriadosPorDia: Map<number, ReadHolidayResponseDto[]>;
  onFeriadoClick: (feriado: ReadHolidayResponseDto) => void;
}

function HolidayCalendarMonthComponent({
  mes,
  ano,
  hoje,
  feriadosPorDia,
  onFeriadoClick,
}: HolidayCalendarMonthProps) {
  const dias = useMemo(() => {
    const diasNoMes = new Date(ano, mes + 1, 0).getDate();
    const primeiroDiaSemana = new Date(ano, mes, 1).getDay();
    const grid: (number | null)[] = [];

    for (let i = 0; i < primeiroDiaSemana; i++) {
      grid.push(null);
    }
    for (let dia = 1; dia <= diasNoMes; dia++) {
      grid.push(dia);
    }
    return grid;
  }, [ano, mes]);

  return (
    <div className="col-md-3 mb-4">
      <div className="card h-100">
        <div className="card-header text-center bg-light">
          <strong>{MESES[mes]} {ano}</strong>
        </div>
        <div className="card-body p-2">
          <div className="calendario-mes">
            <div className="calendario-dias-semana">
              {diasDaSemana.map((dia, index) => (
                <div key={index} className="calendario-dia-semana">
                  {dia}
                </div>
              ))}
            </div>
            <div className="calendario-dias">
              {dias.map((dia, index) => {
                if (dia === null) {
                  return <div key={`${ano}-${mes}-vazio-${index}`} className="calendario-dia vazio" />;
                }

                const dataTime = diaEmTimestamp(ano, mes, dia);
                const feriadosNaData = feriadosPorDia.get(dataTime) ?? [];
                const temFeriado = feriadosNaData.length > 0;

                return (
                  <div
                    key={`${ano}-${mes}-${dia}`}
                    className={`calendario-dia ${dataTime === hoje ? 'hoje' : ''} ${temFeriado ? 'com-evento' : ''}`}
                    onClick={() => {
                      if (temFeriado) onFeriadoClick(feriadosNaData[0]);
                    }}
                    style={{ cursor: temFeriado ? 'pointer' : 'default' }}
                    title={temFeriado ? feriadosNaData.map((f) => f.nome).join(', ') : ''}
                  >
                    {dia}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const HolidayCalendarMonth = memo(HolidayCalendarMonthComponent);
